import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { ISearch } from "type";
import { useExport } from "@pankod/refine-core";
interface Props {
  tag_action_id: number;
  name: string;
  condition_action: string;
  tag_reward_id: number;
  expired_at: string;
  max_received: number;
  created_at: string;
  updated_at: string;
}

export const TagActionList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "tag_action_id",
        title: "Tag Action Id",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "name",
        title: "Name",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 150,
      },
      {
        dataIndex: "condition_action",
        title: "Condition Action",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 150,
      },
      {
        dataIndex: "tag_reward_id",
        title: "Tag Reward Id",
        type: "number",
        headerAlign: "left",
        align: "left",
        width: 150,
      },
      {
        dataIndex: "max_received",
        title: "Max received",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 100,
      },
      {
        dataIndex: "expired_at",
        title: "Expired At",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 200,
      },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 200,
      },
      {
        dataIndex: "updated_at",
        title: "Updated At",
        width: 200,
      },
      {
        dataIndex: "actions",
        title: "Actions",
        render: (_, record) => {
          return (
            <>
              <EditButton hideText recordItemId={record.tag_action_id} />
              <DeleteButton hideText recordItemId={record.tag_action_id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        width: 80,
        fixed: "right",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          {defaultButtons}
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="tag_action_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
